import React, { useState, useEffect } from 'react';
import { Card, Alert, Spinner, Button } from '../../../components/shared';
import { ekycApi } from '../api';

const FIELD_LABELS = {
  fullName: 'Họ và tên',
  idNumber: 'Số CCCD/CMND',
  idType: 'Loại giấy tờ',
  dateOfBirth: 'Ngày sinh',
  gender: 'Giới tính',
  permanentAddress: 'Địa chỉ thường trú',
  verifiedAt: 'Thời gian xác thực',
};

export default function ResultStep({ sessionStatus, extractedData }) {
  const [profile, setProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoadingProfile(true);
      try {
        const res = await ekycApi.getProfile();
        setProfile(res.data);
      } catch {
      } finally {
        setLoadingProfile(false);
      }
    };
    fetchProfile();
  }, []);

  const displayData = profile || extractedData;
  const isVerified = profile?.verified || sessionStatus === 'VERIFIED' || sessionStatus === 'CONFIRMED';

  return (
    <Card title="Kết quả xác thực">
      {loadingProfile ? (
        <div className="flex items-center justify-center py-8">
          <Spinner />
        </div>
      ) : (
        <>
          <Alert type={isVerified ? 'success' : 'info'} className="mb-4">
            {isVerified
              ? 'Xác thực danh tính thành công!'
              : 'Đang chờ duyệt. Hệ thống sẽ thông báo khi hoàn tất.'}
          </Alert>

          {displayData && (
            <div className="divide-y divide-gray-100">
              {Object.entries(FIELD_LABELS).map(([key, label]) => {
                const value = displayData[key];
                if (!value) return null;
                return (
                  <div key={key} className="flex items-center justify-between py-3">
                    <span className="text-sm text-gray-500">{label}</span>
                    <span className="text-sm font-medium text-gray-900">{value}</span>
                  </div>
                );
              })}
            </div>
          )}

          <div className="mt-6 flex justify-center">
            <Button variant="secondary" onClick={() => window.location.href = '/xchange'}>
              Quay lại
            </Button>
          </div>
        </>
      )}
    </Card>
  );
}
